<template>
  <v-app>
    <div class="login-page">
      <div class="login-card">
        <!-- ==================== 左：登录表单 ==================== -->
        <div class="login-form">
          <div class="form-head">
            <v-img src="@/assets/images/logo.png" width="130" class="logo"></v-img>
            <h1 class="form-title">{{ $t('欢迎回来') }}</h1>
            <p class="form-sub">{{ $t('登录您的账户，继续您的建站之旅') }}</p>
          </div>

          <label class="field-label">{{ $t('电子邮件') }}</label>
          <div class="input-wrap">
            <v-icon size="18" color="#9AA5B5" class="mr-2">mdi-email-outline</v-icon>
            <input v-model="params.account" type="text" :placeholder="$t('示例@mail.com')"
              class="field-input" />
          </div>

          <label class="field-label mt-4">{{ $t('登录密码') }}</label>
          <div class="input-wrap">
            <v-icon size="18" color="#9AA5B5" class="mr-2">mdi-lock-outline</v-icon>
            <input type="password" :placeholder="$t('登录密码')" v-model="params.password"
              @keyup.enter="loginfunc" class="field-input" />
          </div>

          <div class="form-actions">
            <!-- 原来指向 /forget-pwd，这个路由并不存在（点了一直是死链）。
                 站上暂时没有自助找回页，先交给 AI 客服给重置路径 -->
            <button type="button" class="forget-link" @click="askReset">{{ $t('忘记密码') }}?</button>
          </div>

          <v-btn color="#7331FF" class="login-btn" block depressed large @click="loginfunc">
            {{ $t('登录') }}
          </v-btn>

          <div class="form-foot">
            <span class="text-caption">{{ $t('还没有账号') }}？</span>
            <router-link to="/sign-up" class="signup-link">{{ $t('注册') }}</router-link>
          </div>
        </div>

        <!-- ==================== 右：品牌插画（窄屏隐藏） ==================== -->
        <div class="login-brand">
          <v-img src="@/assets/images/login/loginbf.png" class="brand-img"></v-img>
          <p class="brand-slogan">{{ $t('专业主题网站模板') }}</p>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import { openChat } from '@/utils/chat'

export default {
  data() {
    return {
      params: {
        account: "",
        password: "",
      },
    };
  },
  mounted() {},
  methods: {
    /** 忘记密码没有自助页，直接问客服要重置路径（用注册邮箱还是人工核验） */
    askReset() {
      openChat(this.$t('我忘记登录密码了，怎么重置'));
    },
    loginfunc() {
      if (this.params.account == '') {
        this.$Toast({ content: this.$t('请输入电子邮件'), type: "error" });
        return
      } else if (this.params.password == '') {
        this.$Toast({ content: this.$t('请输入登陆密码'), type: "error" });
        return
      }
      this.$api.signIn.login(this.params).then((res) => {
        if (res.status) {
          this.$store.commit("setUSERINFO", res.data.user_info);
          this.$router.push("/view-profile");
        } else {
          this.$Toast({ content: res.msg, type: "error" });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/* ===================== 全屏背景（自适应容器） ===================== */
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(135deg, #F5F2FB 0%, #EDE5FF 100%);
}

/* ===================== 登录卡片 ===================== */
.login-card {
  display: flex;
  width: 100%;
  max-width: 940px;
  min-height: 540px;
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 12px 48px rgba(103, 91, 230, 0.18);
}

/* 左：表单 */
.login-form {
  flex: 1.05;
  min-width: 0;
  padding: 48px 56px;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .form-head {
    margin-bottom: 32px;

    .logo {
      margin-bottom: 20px;
    }

    .form-title {
      font-size: 26px;
      font-weight: 700;
      color: #0F3460;
      margin-bottom: 8px;
    }

    .form-sub {
      font-size: 13px;
      color: #8A96A8;
      margin-bottom: 0;
    }
  }

  .field-label {
    font-size: 13px;
    font-weight: 600;
    color: #3D4757;
    margin-bottom: 8px;
    display: block;
  }

  .input-wrap {
    display: flex;
    align-items: center;
    background: #F6F8FC;
    border: 1px solid #E8ECF2;
    border-radius: 10px;
    padding: 0 14px;
    height: 46px;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;

    &:focus-within {
      border-color: #7331FF;
      background: #fff;
      box-shadow: 0 0 0 3px rgba(115, 49, 255, 0.1);
    }

    .field-input {
      flex: 1;
      border: none;
      outline: none;
      background: transparent;
      font-size: 14px;
      height: 100%;
      color: #242939;

      &::placeholder {
        color: #B4BDC9;
      }
    }
  }

  .form-actions {
    display: flex;
    justify-content: flex-end;
    margin: 12px 0 24px;

    .forget-link {
      font-size: 13px;
      color: #7331FF;
      text-decoration: none;
      border: 0;
      background: none;
      padding: 0;
      cursor: pointer;
      font-family: inherit;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .login-btn {
    text-transform: none;
    font-weight: 700;
    font-size: 15px;
    border-radius: 10px;
    height: 48px;
    letter-spacing: 1px;
  }

  .form-foot {
    text-align: center;
    margin-top: 24px;

    .text-caption {
      color: #8A96A8;
    }

    .signup-link {
      font-size: 14px;
      font-weight: 600;
      color: #7331FF;
      text-decoration: none;
      margin-left: 4px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

/* 右：品牌插画 */
.login-brand {
  flex: 1;
  min-width: 0;
  background: linear-gradient(150deg, #7331FF 0%, #9B5CFF 70%, #B07CFF 100%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;

  .brand-img {
    max-width: 100%;
  }

  .brand-slogan {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    margin-top: 16px;
    letter-spacing: 1px;
  }
}

/* ===================== 响应式 ===================== */
/* 平板及以下：隐藏插画，卡片收窄 */
@media (max-width: 991px) {
  .login-brand {
    display: none;
  }

  .login-card {
    max-width: 460px;
    min-height: auto;
  }

  .login-form {
    padding: 44px 40px;
  }
}

/* 手机：卡片全宽 */
@media (max-width: 480px) {
  .login-page {
    padding: 16px;
  }

  .login-card {
    border-radius: 16px;
  }

  .login-form {
    padding: 32px 24px;

    .form-title {
      font-size: 22px;
    }
  }
}
</style>
